// removed by extract-text-webpack-plugin
module.exports = {"component-wrapper":"styles__component-wrapper___1tu6I","component-title":"styles__component-title___1lJ6A","occurences-table":"styles__occurences-table___2P6tJ","table-header":"styles__table-header___2yWce","paramsCell":"styles__paramsCell___3kryY","params-name":"styles__params-name___1Dq97","params-param":"styles__params-param___1U2N-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ReportComponents/Tables/LearnedRuleTable/styles.scss
// module id = 7084
// module chunks = 0